<template>
  <div class="rightTop">
    <div id="top-echarts" ref="topEcharts"></div>
  </div>
</template>

<script>
const echarts = require('echarts')
export default {
  name: 'RightTop',
  data() {
    return {
      rightTopChart: null
    }
  },
  mounted() {
    this.rightTopChart = echarts.init(this.$refs.topEcharts)
    this.initEcharts()
    window.addEventListener('resize', () => {
      this.rightTopChart.resize()
    })
  },

  methods: {
    initEcharts() {
      const option = {
        tooltip: {
          trigger: 'axis',
          formatter: (params, ticket, callback) => {
            let colorList = [
              'rgba(132, 255, 247, 1)',
              'rgba(29, 170, 255, 0.6)',
              'rgba(255, 224, 166, 1)'
            ]
            var showHtm = ''
            var time = ''
            for (var i = 0; i < params.length; i++) {
              time = params[i].axisValue
              // x轴名称
              var name = params[i].seriesName
              var value = ''
              if (params[i].seriesName === '参与率') {
                // 值
                value = params[i].value + '%'
              } else {
                value = params[i].value
              }
              showHtm +=
                `<span style="display: inline-block;width: 10px;height: 10px;border-radius: 50%;background: ${colorList[i]};margin-right: 5px"></span>` +
                name +
                '&nbsp;&nbsp;&nbsp;' +
                value +
                '<br>'
            }
            return time + '<br>' + showHtm
          }
          /*  axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }*/
        },
        legend: {
          data: ['报名人数', '签到人数', '参与率'],
          itemWidth: 10,
          itemHeight: 10,
          textStyle: {
            color: 'rgba(255, 255, 255, 1)',
            fontSize: 12,
            fontFamily: '微软雅黑'
          }
        },
        grid: {
          show: true,
          left: '45',
          top: '35',
          right: '35',
          bottom: '20'
        },
        xAxis: {
          type: 'category',
          data: ['7月', '8月', '9月', '10月', '11月', '12月', '1月'],
          axisPointer: {
            type: 'shadow'
          },
          axisLabel: {
            textStyle: {
              color: '#fff',
              fontSize: 12
            }
          },
          axisTick: {
            show: false
          },
          splitLine: {
            lineStyle: {
              color: '#fff',
              opacity: 0.5
            }
          }
        },
        yAxis: [
          {
            type: 'value',
            name: '人数（人）',
            min: 0,
            max: 3000,
            interval: 500,
            axisLabel: {
              formatter: '{value}',
              textStyle: {
                color: 'rgba(255, 255, 255, 0.65)',
                fontSize: 12
              }
            },
            axisLine: {
              show: true,
              lineStyle: {
                width: 0
              }
            },
            splitLine: {
              lineStyle: {
                type: 'dashed',
                opacity: 0.5,
                width: 0.3
              }
            }
          },
          {
            type: 'value',
            name: '参与率（%）',
            min: 0,
            max: 100,
            interval: 25,
            axisLabel: {
              formatter: '{value}',
              textStyle: {
                color: 'rgba(255, 255, 255, 0.65)',
                fontSize: 12
              }
            },
            axisTick: {
              show: false // 刻度隐藏
            },
            splitLine: {
              lineStyle: {
                type: 'dashed',
                opacity: 0.5,
                width: 0.3
              }
            }
          }
        ],
        series: [
          {
            name: '报名人数',
            type: 'bar',
            barWidth: 8,
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: 'rgba(132, 255, 247, 1)' }, // 柱图渐变色
                  { offset: 1, color: 'rgba(70, 241, 247, 0)' } // 柱图渐变色
                ])
              }
            },
            tooltip: {
              valueFormatter: (value) => {
                return value + ' 人'
              }
            },
            data: [120, 452, 987, 1398, 2876, 2909, 1500]
          },
          {
            name: '签到人数',
            type: 'bar',
            barWidth: 8,
            tooltip: {
              valueFormatter: (value) => {
                return value + ' 人'
              }
            },
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: 'rgba(29, 170, 255, 1)' }, // 柱图渐变色
                  { offset: 1, color: 'rgba(70, 241, 247, 0)' } // 柱图渐变色
                ])
              }
            },
            data: [109, 423, 789, 1387, 2787, 2631, 1488]
          },
          {
            name: '参与率',
            type: 'line',
            yAxisIndex: 1,
            color: 'rgba(255, 224, 166, 1)',
            tooltip: {
              valueFormatter: (value) => {
                return value + ' %'
              }
            },
            data: [90, 93, 79, 99, 96, 90, 99]
          }
        ]
      }
      this.rightTopChart.setOption(option)
    }
  }
}
</script>

<style lang="scss" scoped>
.rightTop {
  width: 100%;
  height: 100%;
  #top-echarts {
    width: 100%;
    height: 100%;
  }
}
</style>
